import { TExcludedCommoditiesSchema } from 'transfix-form/forms/CarrierLoadPreferences/components/ExcludedCommoditiesModal/schema/ExcludedCommoditiesSchema'
import { IExcludedCommodities } from 'transfix-form/forms/CarrierLoadPreferences/components/ExcludedCommoditiesModal/types'
import { IUpdateMotorCarrierExcludedCommoditiesInput } from 'types/FMSGraphqlTypes'
import { ILoadPreferencesFragment } from '../graphql/LoadPreferencesFragment'

export const getUpdateMotorCarrierExcludedCommoditiesInput = ({
  formValues,
  motorCarrierId,
}: {
  formValues: TExcludedCommoditiesSchema
  motorCarrierId: ILoadPreferencesFragment['id']
}): IUpdateMotorCarrierExcludedCommoditiesInput => {
  const {
    alcohol,
    babyFood,
    cosmetic,
    electronic,
    garment,
    jewelry,
    meat,
    medication,
    metal,
    seafood,
    tobacco,
  } = formValues || {}

  return {
    motorCarrierId,
    excludedCommodities: [
      ...(alcohol ? [IExcludedCommodities.ALCOHOL] : []),
      ...(babyFood ? [IExcludedCommodities.BABY_FOOD] : []),
      ...(cosmetic ? [IExcludedCommodities.COSMETIC] : []),
      ...(electronic ? [IExcludedCommodities.ELECTRONIC] : []),
      ...(garment ? [IExcludedCommodities.GARMENT] : []),
      ...(jewelry ? [IExcludedCommodities.JEWELRY] : []),
      ...(meat ? [IExcludedCommodities.MEAT] : []),
      ...(medication ? [IExcludedCommodities.MEDICATION] : []),
      ...(metal ? [IExcludedCommodities.METAL] : []),
      ...(seafood ? [IExcludedCommodities.SEAFOOD] : []),
      ...(tobacco ? [IExcludedCommodities.TOBACCO] : []),
    ],
  }
}
